import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/arrow_out.svg");
;
import(/* webpackMode: "eager" */ "/app/public/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/socials/discord.svg");
;
import(/* webpackMode: "eager" */ "/app/public/socials/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/public/socials/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/public/socials/reddit.svg");
;
import(/* webpackMode: "eager" */ "/app/public/socials/telegram.svg");
;
import(/* webpackMode: "eager" */ "/app/public/socials/x.svg");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/Footer/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/StaticHeader/index.tsx");
